module.exports = __webpack_public_path__ + "static/media/gd-1-20191011-min.1f3972e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/gd-1-20191011-min.png
// module id = 70
// module chunks = 0